import React__default from 'react';
import { Spacing } from '../../primitives/spacing.js';

const extractElementFromChildren = (children, elementType) => React__default.Children.toArray(children).find(child => React__default.isValidElement(child) && child.type === elementType);
const filterOutElements = (children, ...elementTypes) => React__default.Children.map(children, child => {
  if (React__default.isValidElement(child) && elementTypes.includes(child.type)) {
    return null;
  }
  return child;
});
const handleNumberInputWheel = e => {
  e.currentTarget.type === 'number' && e.currentTarget.blur();
};
const getDropdownAlignOffset = size => {
  var _offsets$size;
  const offsets = {
    lg: -parseInt(Spacing.scale[2]),
    md: -parseInt(Spacing.scale[1.5]),
    sm: -parseInt(Spacing.scale[1.5])
  };
  return (_offsets$size = offsets[size]) !== null && _offsets$size !== void 0 ? _offsets$size : offsets.md;
};

export { extractElementFromChildren, filterOutElements, getDropdownAlignOffset, handleNumberInputWheel };
